/* eslint-disable */
export default {
  feedbackHeader: 'Feedback senden',
  back: 'Zurück',
  revert: 'Zurücksetzen',
  instruction:
    'Ihr Feedback ist uns wichtig. Wenn Sie Probleme bei der Verwendung der App haben, eine Funktion anfordern oder einen Fehler melden möchten, helfen wir Ihnen gerne weiter.',
  fillForm:
    'Bitte füllen Sie das unten stehende Formular aus und klicken Sie auf ',
  useMailBox:
    ' oder nutzen Sie direkt Ihr Postfach und senden Sie Ihre Anfrage an ',
  email: 'Ihre E-Mail-Adresse',
  reply: '(damit wir Ihnen antworten können)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Feedbackthema',
  topicPlaceHolder: 'Wählen Sie eine Option aus',
  bugReport: 'Fehlerbericht',
  featureRequest: 'Anfrage von Funktionen',
  others: 'Sonstige',
  subject: 'Betreff',
  subjectPlaceHolder: 'Teilen Sie uns mit, wie wir Ihnen helfen können.',
  description: 'Vollständige Beschreibung',
  descriptionPlaceHolder:
    'Bitte geben Sie so viele Informationen wie möglich an.',
  send: 'Senden Sie Ihr Feedback',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
